
import { z } from "zod";

export const personalInfoSchema = z.object({
  full_name: z.string()
    .min(2, "Name must be at least 2 characters")
    .max(50, "Name must be less than 50 characters"),
  phone: z.string()
    .min(10, "Phone number must be at least 10 digits")
    .optional()
    .or(z.literal("")),
  specialization: z.string()
    .min(2, "Specialization must be at least 2 characters")
    .max(50, "Specialization must be less than 50 characters")
    .optional()
    .or(z.literal("")),
});

export type PersonalInfoFormValues = z.infer<typeof personalInfoSchema>;
